export default __webpack_public_path__ + "static/2-19130a531572001196c09d8b15361967.webp";